
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"25","height":"25"}},[_c('path',{attrs:{"fill":"#D9D9D9","d":"M.476.658h24v24h-24z"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"d":"M9.476 3.658v-2h6v2h-6zm2 11h2v-6h-2v6zm1 8a8.654 8.654 0 01-3.488-.713 9.2 9.2 0 01-2.862-1.938 9.2 9.2 0 01-1.938-2.862 8.654 8.654 0 01-.712-3.487c0-1.234.237-2.396.712-3.489a9.202 9.202 0 011.938-2.861A9.188 9.188 0 018.988 5.37a8.644 8.644 0 013.488-.713 8.92 8.92 0 012.975.5c.95.333 1.841.816 2.675 1.45l1.4-1.4 1.4 1.4-1.4 1.4a9.723 9.723 0 011.45 2.675c.333.95.5 1.941.5 2.975a8.654 8.654 0 01-.712 3.487 9.199 9.199 0 01-1.938 2.863 9.201 9.201 0 01-2.862 1.938 8.654 8.654 0 01-3.488.711zm0-2c1.933 0 3.583-.684 4.95-2.05 1.366-1.367 2.05-3.017 2.05-4.95 0-1.934-.684-3.584-2.05-4.95-1.367-1.367-3.017-2.05-4.95-2.05-1.934 0-3.584.683-4.95 2.05-1.367 1.366-2.05 3.016-2.05 4.95 0 1.933.683 3.583 2.05 4.95 1.366 1.366 3.016 2.05 4.95 2.05z"}})])])
          )
        }
      }
    